import { Injectable } from '@angular/core';
import { BuildSearchFilter } from '@greco/ngx-filters';

@Injectable({ providedIn: 'any' })
export class UserPerkSearchFilter extends BuildSearchFilter('UserPerkSearchFilter', {
  properties: ['user.displayName', 'user.email', 'user.contactEmail', 'perk.title'],
  propertyLabels: ['User Name', 'Email Address', 'Perk Title'],
}) {}
